import styled from "@emotion/styled";

export const StyledRadioBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const StyledRadioLabel = styled.label`
  display: flex;
  align-items: center;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 400;
  line-height: 15.23px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  & input:checked + span {
    color: ${({ theme }) => theme.palette.secondary.green[500]};
  }
`;
